{
    "userSettings": {},
    "originalImage": {
        "data": "https://static1.anpoimages.com/wordpress/wp-content/uploads/2021/02/23/Save-to-Google-Drive-Hero.png?q=50&fit=contain&w=1500&h=721&dpr=1.5",
        "mimeType": "image/png",
        "width": 1500,
        "height": 721
    }    
}
  